import { queryOptions, useQuery } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoLocalEstoqueSchema } from '../types/ProdutoLocalEstoque';

export type ApiProdutoLocalEstoqueGetParams = DefaultApiParams & {
    pesquisar?: string;
};

type ApiProdutoLocalEstoqueGetProps = {
    idpk?: number;
    params?: ApiProdutoLocalEstoqueGetParams;
};

const schema = registrosSchema(ProdutoLocalEstoqueSchema);

function apiProdutoLocalEstoqueGet({ idpk, params }: ApiProdutoLocalEstoqueGetProps) {
    return fetchApi({
        endpoint: 'Estoque/Consultar',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_PRODUTO_LOCAL_ESTOQUE_GET_KEY = 'apiProdutoLocalEstoqueGet';

export function apiProdutoLocalEstoqueGetQueryOptions(props: ApiProdutoLocalEstoqueGetProps) {
    return queryOptions({
        queryFn: () => apiProdutoLocalEstoqueGet(props),
        queryKey: [API_PRODUTO_LOCAL_ESTOQUE_GET_KEY, props],
    });
}

export function useQueryProdutoLocalEstoqueGet() {
    return useQuery({
        ...apiProdutoLocalEstoqueGetQueryOptions({
            params: {
                orderby: 'est_status, est_padrao desc, est_descricao',
            },
        }),
        gcTime: Infinity,
        staleTime: Infinity,
    });
}
